export default {
  api: require('./api').default
}
